import { useState, useEffect } from "react";
import axios from "axios";
import MyAppointments from "./MyAppointments";

export default function BookAppointment() {
  const [lawyers, setLawyers] = useState([]);
  const [form, setForm] = useState({
    lawyerId: "",
    date: new Date().toISOString().split("T")[0], // default to today
    time: "10:00",
    notes: "",
  });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  // Fetch list of lawyers
  useEffect(() => {
    axios
      .get(`${process.env.REACT_APP_BACKEND_URL}/api/admin`, { withCredentials: true })
      .then((res) => setLawyers(res.data))
      .catch((err) => console.log(err));
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);

    const token = localStorage.getItem("token");
    if (!token) {
      alert("You must be logged in to book an appointment.");
      setLoading(false);
      return;
    }

    try {
      await axios.post(`${process.env.REACT_APP_BACKEND_URL}/api/appointments`, form, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
        withCredentials: true,
      });
      alert("Appointment requested successfully");

      // Reset form
      setForm({
        lawyerId: "",
        date: new Date().toISOString().split("T")[0],
        time: "10:00",
        notes: "",
      });
    } catch (err) {
      console.error(err);
      setError("Failed to request appointment. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div>
         <h2 className="text-xl font-semibold mb-4 text-white">Book Appointment</h2>
  <div className="max-w-xl mx-auto p-4 bg-white shadow rounded">
   

      {error && <p className="text-red-600 mb-2">{error}</p>}

      <form onSubmit={handleSubmit} className="space-y-3">
        <select
          value={form.lawyerId}
          onChange={(e) => setForm({ ...form, lawyerId: e.target.value })}
          className="w-full p-2 border rounded"
          required
        >
          <option value="">Select Lawyer</option>
          {lawyers.map((lawyer) => (
            <option key={lawyer._id} value={lawyer._id}>
              {lawyer.name}
            </option>
          ))}
        </select>

        <input
          type="date"
          className="w-full p-2 border rounded"
          value={form.date}
          onChange={(e) => setForm({ ...form, date: e.target.value })}
          required
        />

        <input
          type="time"
          className="w-full p-2 border rounded"
          value={form.time}
          onChange={(e) => setForm({ ...form, time: e.target.value })}
          required
        />

        <textarea
          placeholder="Notes"
          className="w-full p-2 border rounded"
          value={form.notes}
          onChange={(e) => setForm({ ...form, notes: e.target.value })}
        ></textarea>

        <button
          type="submit"
          disabled={loading}
          className={`bg-blue-600 text-white px-4 py-2 rounded ${
            loading ? "opacity-50 cursor-not-allowed" : ""
          }`}
        >
          {loading ? "Booking..." : "Book"}
        </button>
      </form>

    </div>
    <MyAppointments/>

    </div>
  
  );
}
